import { render, staticRenderFns } from "./EnderecosManager.vue?vue&type=template&id=5946442e&scoped=true"
import script from "./EnderecosManager.vue?vue&type=script&lang=js"
export * from "./EnderecosManager.vue?vue&type=script&lang=js"
import style0 from "./EnderecosManager.vue?vue&type=style&index=0&id=5946442e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5946442e",
  null
  
)

export default component.exports